import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import moment from "moment";
import DataTable from "react-data-table-component";
import {
    getTabTotal, getTabColumns, getGroupedSeriesByGroupIdForTab,
    getGroupedSeriesByGroupmentForTab, GetXLSXDataTab, getGroupedSeriesByUUID
} from './ChartsV2Functions';
import "./ChartV2.css";
import uuid from "react-uuid";
import styled from "styled-components";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const customStyles = {
    rows: {
        style: {
            minHeight: '30px', // override the row height
        }
    },

    head: {
        style: {
            fontWeight: '600 !important',
        },
    },
    header: {
        style: {
            fontWeight: '600 !important',
        },
    },
    headRow: {
        style: {
            fontWeight: '600 !important',
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            fontWeight: '600 !important',
            fontSize: '13px'
        },
    },
    cells: {
        style: {
            padding: '8px', // override the cell padding for head cells
        },
    },
};

export default function ChartV2Tab(props) {
    const { chart, data, setData } = props;
    const [groupedseries, setGroupedseries] = useState([]);
    const [tabcolumns, setTabcolumns] = useState([]);

    useEffect(() => {
        // chart.series.forEach((serie) => {
        //     serie.uuid = uuid();
        // });
        
        let groupedseriestmp;
        if (chart.distribution === 'no') {
            // console.log("getGroupedSeriesByUUID", chart.series);
            groupedseriestmp = getGroupedSeriesByUUID(chart);
        }
        else if (!chart.distributiongroupment || chart.distributiongroupment === 'no') {
            groupedseriestmp = getGroupedSeriesByGroupIdForTab(chart);
        }
        else
            groupedseriestmp = getGroupedSeriesByGroupmentForTab(chart);

        let tabcolumnstmp = getTabColumns(chart);
        if(chart.tabparameters?.displaytotal)
        {
            getTabTotal(chart, groupedseriestmp);
        }
        setData(groupedseriestmp);
        console.log(tabcolumnstmp);
        console.log(groupedseriestmp);
        setGroupedseries(groupedseriestmp);
        setTabcolumns(tabcolumnstmp);
        GetXLSXDataTab(chart, groupedseriestmp);

    }, []);

    const conditionalRowStyles = [
        {
            when: row => (row.total),
            style: {
                fontWeight: '600',
            },
        },
    ];


    return (
        <>
            <DataTable
                striped={true}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                noDataComponent={<NoData>Aucune donnée</NoData>}
                noHeader={true}
                columns={tabcolumns}
                persistTableHead
                pagination
                paginationComponentOptions={{
                    noRowsPerPage: false,
                    rowsPerPageText: "Lignes par page",
                    rangeSeparatorText: "sur",
                    selectAllRowsItem: false,
                    selectAllRowsItemText: "Selectionner toutes les lignes",
                }}
                defaultPageSize={10}
                data={data}
                paginationTotalRows={data.length}
                filterable={true}
                manual={true}
                customStyles={customStyles}
                conditionalRowStyles={conditionalRowStyles}
            />
        </>

    );
}